import React from 'react';
import '../Style/Home.css';
import imm from '../Images/img-header.svg';
import task from '../Images/task.png';
import abc from '../Images/abc.png';
import chat from '../Images/chat.png';
import clock from '../Images/clock.png';
import BtnCoustom from '../Components/ButtonCstoum';
import BrandsSlider from './BrandsSlider';
import LessWorry from './SectionLessWorry';
import RileyWorks from './RileyWorks';
import ParentsLove from './ParentsLove';
import FAQ from './FAQ';
import { useEffect, useState } from 'react';


function Home() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => setLoaded(true), 100); // delay صغير للأنيميشن
  }, []);
  return (
    <>
      <div className='container-fluid min-vh-100 Home-custom m-0'>
      <div className={`hero-section row d-flex justify-content-center align-items-center min-vh-100 text-center ${loaded ? 'animate-on-load' : ''}`}>
        
        <div className='col-lg-6 col-sm-12 container row d-flex justify-content-center'>
          <h1 className='display-3 fw-bold fade-up delay-1'>Your smart parenting companion</h1>
          <p className='fade-up delay-2'>
            From newborn to toddler and beyond: Riley is the only AI-powered assistant that grows with your family.
          </p>
          <div className='fade-up delay-3'>
            <BtnCoustom />
          </div>
        </div>

        <div className='col-lg-6 col-sm-12 position-relative d-flex justify-content-center align-items-center fade-in delay-4'>
          <img src={imm} alt='main' className='main-img' />

          <div className='icon task-icon fade-icon delay-5' style={{ top: '15%', left: '30%' }}>
            <img src={task} alt='task' className='icon-img' />
          </div>
          <div className='icon task-icon fade-icon delay-6' style={{ top: '25%', right: '30%' }}>
            <img src={abc} alt='abc' className='icon-img' />
          </div>
          <div className='icon task-icon fade-icon delay-7' style={{ bottom: '25%', left: '25%' }}>
            <img src={chat} alt='chat' className='icon-img' />
          </div>
          <div className='icon task-icon fade-icon delay-8' style={{ bottom: '20%', right: '25%' }}>
            <img src={clock} alt='clock' className='icon-img' />
          </div>
        </div>

        <BrandsSlider />
      </div>
    </div>
      <LessWorry />
      <RileyWorks />
      <ParentsLove />
      <FAQ />
    </>
  );
}

export default Home;
